module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (231).9c464aca.jpg";